import axios from "axios";
import { API_BASE_URL } from "../config";
import { unwrapApiResponse } from "../utils/apiResponse";
import { getRefreshToken, persistSession, clearSession } from "../utils/tokenStorage";

/** Bare client — no interceptors — avoids refresh loops and circular imports. */
const bareClient = axios.create({ baseURL: API_BASE_URL });

export const refreshSession = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    throw new Error("No refresh token available.");
  }

  const response = await bareClient.post("/api/auth/refresh", {
    refreshToken,
  });
  const data = unwrapApiResponse(response);

  if (!data?.accessToken || !data?.refreshToken) {
    throw new Error("Refresh did not return access and refresh tokens.");
  }

  persistSession({
    accessToken: data.accessToken,
    refreshToken: data.refreshToken,
    user: data.user,
  });

  return data.accessToken;
};

export const revokeRefreshToken = async () => {
  const refreshToken = getRefreshToken();
  if (!refreshToken) return;

  try {
    await bareClient.post("/api/auth/logout", { refreshToken });
  } catch {
    // Ignore — local session is cleared regardless.
  } finally {
    clearSession();
  }
};
